import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CashierService } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';

import { BetslipOverAskActions } from '../../../actions';
import { OverAskTrackingActions } from '../../../tracking.actions';

@Component({
    selector: 'bs-betslip-over-ask-header',
    templateUrl: './betslip-over-ask-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betslip-over-ask-header.component.scss'],
    standalone: false,
})
export class BetslipOverAskHeaderComponent {
    @HostBinding('class.over-ask-header') hostCssClass = true;

    readonly messages: {
        title: string;
        deposit: string;
        closeBetslip: string;
    };

    constructor(
        private store: Store,
        private sitecore: Sitecore,
        private cashierService: CashierService,
    ) {
        this.messages = {
            title: this.sitecore.betslip.messages.Title,
            deposit: this.sitecore.betslip.messages.Deposit,
            closeBetslip: this.sitecore.betslip.messages.CloseBetslip,
        };
    }

    onCancelClick(): void {
        this.store.dispatch(BetslipOverAskActions.userRequestRejectOffer());
        this.store.dispatch(OverAskTrackingActions.trackClose({ method: 'close x' }));
    }

    goToDeposit(): void {
        this.cashierService.goToCashierDeposit({});
    }
}
